import { useState } from'react';
const usePagination = () => {
    const [page, setPage] = useState<number>(1);
    const [pageSize,setPageSize] = useState<number>(15);
    const [total, setTotal] = useState<number>(0);
    const [flag,setFlag] = useState<boolean>(true);
    const [curType,setCurType] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);

    return {
        page,
        setPage,
        pageSize,
        setPageSize,
        total,
        setTotal,
        flag,
        setFlag,
        curType,
        setCurType,
        isModalOpen,
        setIsModalOpen
    };
};

export default usePagination;